import { Dialog } from "primereact/dialog";
import { Button } from "primereact/button";
import { IFAQ } from "../../models/BaseModel";
import { Controller, useForm } from 'react-hook-form';
import { yupResolver } from "@hookform/resolvers/yup";
import * as yup from "yup";
import { useEffect, useState } from "react";
import { Fetch } from "../../shared/Fetch";
import { InputTextarea } from "primereact/inputtextarea";

const schema = yup.object({
    question: yup.string().required("Question is required*"),
    answer: yup.string().required("Answer is required*"),
});

interface Iprops {
    singleData: IFAQ,
    open: boolean,
    hideDialog: () => void,
    toast: any,
    reloadData: () => void,
    hasPermission: (pageName: string, featureName?: string) => boolean
}

export const Form = (props: Iprops) => {
    const [submitting, setSubmitting] = useState(false);

    const { control, handleSubmit, formState: { errors }, reset } = useForm<IFAQ>({
        resolver: yupResolver(schema),
        defaultValues: props.singleData,
        shouldFocusError: false,
    });

    useEffect(() => {
        reset(props.singleData);
    }, [props.singleData]);


    const saveToDB = async (body: IFAQ) => {
        setSubmitting(true);
        const method = props.singleData.id ? "PUT" : "POST";
        const message = props.singleData.id ? "Updated Successfully" : "Added Successfully";
        const response = await Fetch(`FAQ${props.singleData.id ? '/' + props.singleData.id : ''}`, method, body, null, props.toast);
        if (response) {
            onHide();
            props.toast.current.show({ severity: 'success', detail: message, life: 3000 });
            props.reloadData();
        }
        setSubmitting(false);
    }

    const onHide = () => {
        props.hideDialog();
        reset({});
    }

    function onSubmit(data: any) {
        saveToDB(data);
    }

    return (
        <Dialog visible={props.open} style={{ width: '80vw', maxWidth: '600px' }} header="Add/Edit FAQ" modal className="p-fluid" onHide={onHide}>
            <form onSubmit={handleSubmit(onSubmit)} className="p-fluid formgrid grid">
                <div className="field col-12 md:col-12 mt-0">
                    <label htmlFor="question"> Question<span style={{ color: 'red' }}>*</span> </label>
                    <Controller
                        name="question"
                        control={control}
                        rules={{ required: "Question is required" }}
                        render={({ field }) => (
                            <InputTextarea
                                value={field.value || ""}
                                onChange={(e) => field.onChange(e.target.value)}
                                onBlur={field.onBlur}
                                rows={5}
                                cols={20}
                            />

                        )}
                    />
                    {errors.question && <small className="p-error">{errors.question.message}</small>}

                    <label htmlFor="answer"> Answer<span style={{ color: 'red' }}>*</span> </label>

                    <Controller
                        name="answer"
                        control={control}
                        rules={{ required: "Answer is required" }}
                        render={({ field }) => (
                            <InputTextarea
                                value={field.value || ""}
                                onChange={(e) => field.onChange(e.target.value)}
                                onBlur={field.onBlur}
                                rows={5}
                                cols={20}
                            />
                        )}
                    />
                    {errors.answer && <small className="p-error">{errors.answer.message}</small>}

                </div>
                <div className="col-12 md:col-12 flex gap-4 justify-content-end mt-2">
                    <Button style={{ width: '100px' }} loading={submitting} label="SAVE" type="submit" className="p-button-rounded"></Button>
                    <Button style={{ width: '100px' }} label="CLOSE" onClick={onHide} type="button" className="p-button-rounded p-button-outlined surface-200"></Button>
                </div>
            </form>
        </Dialog>
    );
}